import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import useFetch from 'use-http';
import { CreateScimAuthTokenDocument, SetIdpConfigDefaultConnectionDocument, SetIdpConfigEnableAllDocument, UpdateMfaConifgDocument, useConfigCallQuery as _useConfigCallQuery, useCreateOidcConnectionMutation as _useCreateOidcConnection, useCreateSamlConnectionMutation as _useCreateSamlConnectionMutation, useGetAttributeMappingQuery as _useGetAttributeMappingQuery, useGetIdpConfigLazyQuery as _useGetIdpConfigLazyQuery, useGetMfaConfigLazyQuery as _useGetMfaConfigLazyQuery, useGetOidcAttributeMappingsQuery as _useGetOidcAttributeMappingsQuery, useGetSamlConnectionQuery as _useGetSamlConnectionQuery, useGetSamlMetadataInfoQuery as _useGetSamlMetadataInfoQuery, useGetScimAuthTokenLazyQuery as _useGetScimAuthTokenLazyQuery, useSaml_DownloadQuery as _useSaml_DownloadQuery, useSamlActDeactConnectionMutation as _useSamlActDeactConnectionMutation, useSamlConnectionListQuery as _useSamlConnectionListQuery, useSamlDeleteConnectionMutation as _useSamlDeleteConnectionMutation, useSetMfaTscliCommandMutation as _useSetMfaTscliCommandMutation, useUpdateAttributeMappingMutation as _useUpdateAttributeMappingMutation, useUpdateOidcConnectionMutation as _useUpdateOidcConnectionMutation, useUpdateSamlConnectionMutation as _useUpdateSamlConnectionMutation, useUploadMetatDataMutation as _useUploadMetatDataMutation, } from '../generated/graphql-types';
export const useUploadMetatDataMutation = (onComplete, onError, data) => _useUploadMetatDataMutation({
    variables: {
        data,
    },
    update: (cache, result) => {
        onComplete(result?.data.Saml_uploadMetaData);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useCreateSamlConnectionMutation = (onComplete, onError, data) => _useCreateSamlConnectionMutation({
    variables: {
        data,
    },
    update: (cache, result) => {
        onComplete(result?.data.Saml_createConnection);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useCreateOidcConnectionMutation = (onComplete, onError, data) => _useCreateOidcConnection({
    variables: {
        data,
    },
    update: (cache, result) => {
        onComplete(result?.data.OIDC_createConnection);
    },
    onError: (error) => {
        onError(error);
    },
});
export const SamlConnectionListQuery = (dataProps) => {
    const { skip, ...data } = dataProps;
    const { data: queryData, error, loading, refetch, } = _useSamlConnectionListQuery({
        variables: {
            data,
        },
        fetchPolicy: 'no-cache',
        skip,
    });
    return {
        error,
        loading,
        data: queryData?.Saml_getConnectionList,
        refetch,
    };
};
export const useConfigCallQuery = () => {
    const { data, error, loading } = _useConfigCallQuery({
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.Config_Query,
    };
};
export const useSamlActDeactConnectionMutation = (onComplete, onError, data) => _useSamlActDeactConnectionMutation({
    variables: {
        data,
    },
    update: (cache, result) => {
        onComplete(result?.data.Saml_updateConnectionStatus);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useUpdateSamlConnectionMutation = (onComplete, onError, data) => _useUpdateSamlConnectionMutation({
    variables: {
        data,
    },
    update: (cache, result) => {
        onComplete(result?.data.Saml_updateConnection);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useSamlDeleteConnectionMutation = (onComplete, onError, data) => _useSamlDeleteConnectionMutation({
    variables: {
        data,
    },
    update: (cache, result) => {
        onComplete(result?.data.Saml_deleteConnection);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useSaml_DownloadQuery = (idData) => {
    const { skip, ...queryData } = idData;
    const { data, error, loading } = _useSaml_DownloadQuery({
        variables: {
            data: queryData,
        },
        skip: skip || !idData.id,
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.Saml_downloadMetadata,
    };
};
export const useGetSamlMetadataInfoQuery = (dataProps) => {
    const { skip, ...queryData } = dataProps;
    const { data, error, loading } = _useGetSamlMetadataInfoQuery({
        variables: {
            data: queryData,
        },
        skip: skip || !dataProps.id,
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.Saml_metadataInfo,
    };
};
export const useGetAttributeMappingQuery = (dataProps) => {
    const { data, error, loading } = _useGetAttributeMappingQuery({
        variables: {
            data: dataProps,
        },
        skip: !dataProps.id,
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.Saml_getAttributeMapping,
    };
};
export const useUpdateAttributeMappingMutation = (onComplete, onError, data) => _useUpdateAttributeMappingMutation({
    variables: {
        data,
    },
    update: (cache, result) => {
        onComplete(result?.data.Saml_updateAttributeMapping);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useGetSamlConnectionQuery = (idData) => {
    const { data, error, loading } = _useGetSamlConnectionQuery({
        variables: {
            data: idData,
        },
        skip: !idData.id,
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.Saml_getConnection,
    };
};
export const useUpdateOIDCConnecitonMutation = (onComplete, onError, data) => _useUpdateOidcConnectionMutation({
    variables: {
        data,
    },
    update: (cache, result) => {
        onComplete(result?.data.Oidc_updateConnection);
    },
    onError: (error) => {
        onError(error);
    },
});
export const getPublicSamlConnections = (url) => {
    const { data, error, loading } = useFetch(url, { data: [] }, []);
    return {
        error,
        loading,
        data,
    };
};
export const useGetOidcAttributeMappingsQuery = (idData) => {
    const { data, error, loading } = _useGetOidcAttributeMappingsQuery({
        variables: {
            data: idData,
        },
        skip: !idData.id,
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.OIDC_getMappings,
    };
};
export const useGetMfaConfigLazyQuery = () => {
    const [_getConfigInfo, { data, error, loading },] = _useGetMfaConfigLazyQuery({
        fetchPolicy: 'network-only',
    });
    const MfaConfigInfo = data?.Mfa__GetConfigInfo?.Data;
    const getMfaConfigInfo = (queryData) => {
        return _getConfigInfo({
            variables: {
                data: queryData,
            },
        });
    };
    return {
        getMfaConfigInfo,
        error,
        loading,
        MfaConfigInfo,
    };
};
export const useUpdateMfaConifgMutation = () => {
    const [_updateMfaConfig, { data: result, error, loading }] = useMutation(UpdateMfaConifgDocument);
    return {
        data: result?.Mfa_updateConfig,
        error,
        loading,
        updateMfaConfig: (queryData) => _updateMfaConfig({
            variables: {
                data: queryData,
            },
        }),
    };
};
export const useSetMfaTscliCommand = (featureName, params) => _useSetMfaTscliCommandMutation({
    variables: {
        featureName,
        params,
    },
});
export const useGetScimAuthTokenLazyQuery = () => {
    const [_getScimToken, { data, error, loading },] = _useGetScimAuthTokenLazyQuery({
        fetchPolicy: 'network-only',
    });
    const ScimTokenAuthData = data?.Admin_getScimAuthToken?.Data;
    const getScimToken = (viewMode) => {
        return _getScimToken({
            variables: {
                viewMode,
            },
        });
    };
    return {
        getScimToken,
        error,
        loading,
        ScimTokenAuthData,
    };
};
export const useGetIdpConfigLazyQuery = () => {
    const [_getIdpConfig, { data, error, loading }] = _useGetIdpConfigLazyQuery({
        fetchPolicy: 'network-only',
    });
    const idpConfig = data?.Admin_getIdpConfig?.Data;
    const getIdpConfig = useCallback((viewMode) => _getIdpConfig({
        variables: {
            viewMode,
        },
    }), [_getIdpConfig]);
    return {
        getIdpConfig,
        error,
        loading,
        idpConfig,
    };
};
export const useSetIdpConfigEnableAllMutation = () => {
    const [_setIdpConfigEnableAll, { data: result, error, loading },] = useMutation(SetIdpConfigEnableAllDocument);
    const setIdpConfigEnableAll = useCallback((viewMode, enableAllConnectionsOnLoginPage) => _setIdpConfigEnableAll({
        variables: {
            viewMode,
            enableAllConnectionsOnLoginPage,
        },
    }), [_setIdpConfigEnableAll]);
    return {
        data: result?.Admin_setIdpConfigEnableAll,
        error,
        loading,
        setIdpConfigEnableAll,
    };
};
export const useSetIdpConfigDefaultConnectionMutation = () => {
    const [_setIdpConfigDefaultConnection, { data: result, error, loading },] = useMutation(SetIdpConfigDefaultConnectionDocument);
    const setIdpConfigDefaultConnection = useCallback((viewMode, defaultConnectionId) => _setIdpConfigDefaultConnection({
        variables: {
            viewMode,
            defaultConnectionId,
        },
    }), [_setIdpConfigDefaultConnection]);
    return {
        data: result?.Admin_setIdpConfigDefaultConnection,
        error,
        loading,
        setIdpConfigDefaultConnection,
    };
};
export const useCreateScimTokenMutation = () => {
    const [_createScimToken, { data: result, error, loading }] = useMutation(CreateScimAuthTokenDocument);
    return {
        data: result?.Admin_createScimAuthToken,
        error,
        loading,
        createScimToken: (viewMode) => {
            return _createScimToken({
                variables: {
                    viewMode,
                },
            });
        },
    };
};
//# sourceMappingURL=saml-service.js.map